<template>
  <div>
    <titulo-formas-pagamento @cadastrar="openModal" />
    <filtro
      :items="items"
      @limpar="limpar"
      @filtrar="buscarFormasPagamento"
      @atualizar-filtro="atualizarFiltro"
    />
    <!-- <Tabela :items="items" @editar="openModal" @excluir="confirmarExclusao" @alterar-ordenacao="novaOrdenacao"/> -->
    <b-table
      :items="items"
      :fields="fields"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      show-empty
      striped
      hover
      no-local-sorting
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
          <b-dropdown-item @click="openModal('formaPagamento', item.item)" v-if="podeEditar">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="buscarFormasPagamento"
    />

    <modal-forma-pagamento
      :id="modais.formaPagamentoDados.id"
      :exibir="modais.formaPagamento"
      @salvar="salvar"
      @fechar="closeModal('formaPagamento')"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import FormaPagamentoService from '@/common/services/financeiro/formaPagamento.service.js';

// Components:
import helpers from '@/common/utils/helpers';
import ModalFormaPagamento from './components/Modal';
import Filtro from './components/Filtro';
import TituloFormasPagamento from '@/views/financeiro/estrutura/formas-pagamento/components/TituloFormasPagamento';
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  mixins: [Permissoes],
  components: {
    TituloFormasPagamento,
    ModalFormaPagamento,
    Filtro,
    Paginacao,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'tipoFormaPagamentoDescricao',
          label: 'Tipo',
          sortable: true,
        },
        {
          key: 'descricao',
          label: 'Descrição',
          sortable: true,
        },
        {
          key: 'parcelasResiduais',
          label: 'Parcela residual',
          sortable: true,
        },
        {
          key: 'diaVencimento',
          label: 'Dia de vencimento padrão',
          sortable: true,
        },
        {
          key: 'mesReferenciaDescricao',
          label: 'Mês referência',
          sortable: true,
          formatter: (value) => {
            return value == 0 ? '' : value;
          },
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      filtro: {},
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      modais: {
        formaPagamento: false,
        formaPagamentoDados: {},
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.buscarFormasPagamento();
  },
  methods: {
      // FUNÇÕES OBTENÇÃO DE DADOS:
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      this.campoOrdenado = campoOrdenado;
      this.ordem = !sortDesc;
      this.buscarFormasPagamento(); 
    },

    buscarFormasPagamento() {
      this.$store.dispatch(START_LOADING);

      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado :this.campoOrdenado, 
        OrdenacaoAscendente: this.ordem,
        ...this.filtro
      }
      FormaPagamentoService.obterPorFiltroPaginado(param)
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // FUNÇÕES AUXILIARES:
    // FUNÇÕES CRUD:
    salvar(item) {
      item.id ? this.editar(item) : this.criar(item);
    },

    criar(item) {
      this.$store.dispatch(START_LOADING);
      FormaPagamentoService.criar(item)
        .then(() => {
          this.closeModal('formaPagamento');
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('FINANCEIRO.FORMA_PAGAMENTO_CRIADA')
          );
          this.buscarFormasPagamento();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    editar(item) {
      this.$store.dispatch(START_LOADING);
      FormaPagamentoService.editar(item)
        .then(() => {
          this.closeModal('formaPagamento');
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('FINANCEIRO.FORMA_PAGAMENTO_EDITADA')
          );
          this.buscarFormasPagamento();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('GERAL.CONFIRMAR_EXCLUSAO'),
        this.$t('FINANCEIRO.FORMA_PAGAMENTO_CONFIRMAR_EXCLUSAO')
      );
      respostaExclusao.isConfirmed ? this.excluir(item) : {};
    },
    excluir(item) {
      this.$store.dispatch(START_LOADING);
      FormaPagamentoService.excluir(item.id)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('FINANCEIRO.FORMA_PAGAMENTO_DELETADA')
          );
          this.buscarFormasPagamento();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // FILTRO
    atualizarFiltro(_filtro) {
      this.filtro = _filtro;
    },

    limpar() {
      this.items = [];
      this.filtro = {};
      this.paginacao = {};
    },

    // FUNÇÕES MODAL
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },

    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.buscarFormasPagamento(); 
    },
  },
};
</script>
